<template>
  <b-form-group
    label="Özet İçerik"
    label-for="summary"
  >
    <b-form-textarea
      id="summary"
      v-model="dataItem.summary"
      placeholder="Özet İçerik"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'ProductSummary',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
